import React, { Suspense, useState } from "react";
import { Route, Routes } from "react-router-dom";
import { HelmetProvider } from "react-helmet-async";
import Dashboard from "../Dashboard/Dashboard";
import Login from "../Login/login";
import Preferences from "../Preferences/Preferences";
// import useToken from './useToken';
import PageWrapper from "../PageWrapper/PageWrapper";
import HomePage from "../HomePage/HomePage";
import CategorySearchResults from "../CategoryResults/CategorySearchResults.js";
import ItemSearchResults from "../SearchResults/ItemSearchResults.js";
import SpecialPage from "../SpecialPage/SpecialPage";
import Portal from "../Portal/Portal";
import {
  GetCart,
  Increment,
  Decrement,
  Remove,
  GetCount,
} from "../ShoppingCart/CartHandler.js";
import ShoppingCart from "../ShoppingCart/ShoppingCart";
import { useEffect } from "react";
import CategoryProducts from "../CategoryDisplay/CategoryProducts.js";
import NewFooter from "../Footer/NewFooter.js";
import { ThemeProvider } from "@emotion/react";
import Cart from "../ShoppingCart/Cart.js";
import "../App/app.css"
import Activities from "../Portal/Activities.js";


const CustomerRoutes = () => {
  const [token, setToken] = useState();
  const [cartCount, setCartCount] = useState();
  const [category, setCategory] = useState({ name: "All" });
  const [categories, setCategories] = useState([]);
  const [page, setPage] = useState();
  const helmetContext = {};
  const [search, setSearch] = useState([]);
  const [tempToken, setTempToken] = useState([]);

  useEffect(() => {
    // console.log("here is your token at App.js", token);
    if (token) {
      sessionStorage.setItem("token", JSON.stringify(token));
    } else {
      if (sessionStorage.getItem("token")) {
        setToken(JSON.parse(sessionStorage.getItem("token")));
      }
    }
  }, [token]);

  useEffect(() => {
    setCartCount(GetCount());
  }, []);

  if (!token) {
    return <Login token={token} setToken={setToken} />;
  }

  return (
    <div  className="home-cover" >
      <HelmetProvider context={helmetContext} className=" container">
        <PageWrapper
          search = {search}
          token={token}
          setSearch={setSearch}
          category={category}
          setCategory={setCategory}
          page={page}
          setPage={setPage}
          categories={categories}
          setCategories={setCategories}
          cartCount={cartCount}
          setCartCount={setCartCount}
        ></PageWrapper>
        <Routes>
          <Route
            path="/dashboard"
            element={<Dashboard token={token} setToken={setToken} />}
          />
          <Route
            path="/preferences"
            element={<Preferences token={token} setToken={setToken} />}
          />
          <Route
            path="/ItemSearchResults"
            element={
              <ItemSearchResults
                token={token}
                setToken={setToken}
                search={search}
                category={category}
                setCategory={setCategory}
                categories={categories}
                setCategories={setCategories}
                cartCount={cartCount}
                setCartCount={setCartCount}
              />
            }
          />

          <Route
            path="/categoryItems"
            element={
              <CategoryProducts
                token={token}
                setToken={setToken}
                category={category}
                setCategory={setCategory}
                cartCount={cartCount}
                setCartCount={setCartCount}
              />
            }
          />

          <Route
            path="/"
            element={
              <HomePage
                token={token}
                setToken={setToken}
                category={category}
                setCategory={setCategory}
                categories={categories}
                setCategories={setCategories}
                cartCount={cartCount}
                setCartCount={setCartCount}
              />
            }
          />

          <Route
            path="/specialPage"
            element={
              <Suspense
                token={token}
                setToken={setToken}
                page={page}
                setPage={setPage}
                fallback={<div>Loading...</div>}
              >
                <SpecialPage
                  token={token}
                  setToken={setToken}
                  page={page}
                  setPage={setPage}
                />
              </Suspense>
            }
          ></Route>

          <Route
            path="/CategorySearchResults"
            element={
              <Suspense
                token={token}
                setToken={setToken}
                fallback={<div>Loading...</div>}
              >
                <CategorySearchResults
                  token={token}
                  setToken={setToken}
                  category={category}
                  setCategory={setCategory}
                  page={page}
                  setPage={setPage}
                  cartCount={cartCount}
                  setCartCount={setCartCount}
                />
              </Suspense>
            }
          ></Route>


          <Route
            path="/myCart"
            element={
              <Suspense
                token={token}
                setToken={setToken}
                fallback={<div>Loading...</div>}
              >
                <Cart
                  token={token}
                  setToken={setToken}
                  cartCount={cartCount}
                  setCartCount={setCartCount}
                />
              </Suspense>
            }
          ></Route>

          <Route
            path="/activities"
            element={
              <Suspense
                token={token}
                setToken={setToken}
                fallback={<div>Loading...</div>}
              >
                <Activities
                  token={token}
                  setToken={setToken}
                  cartCount={cartCount}
                  setCartCount={setCartCount}
                />
              </Suspense>
            }
          ></Route>

          <Route
            path="/portal"
            element={
              <Suspense
                token={token}
                setToken={setToken}
                fallback={<div>Loading...</div>}
              >
                <Portal
                  token={token}
                  setToken={setToken}
                  cartCount={cartCount}
                  setCartCount={setCartCount}
                />
              </Suspense>
            }
          ></Route>
          {/* <Route path="/login" element={<Login token={token} setToken = {setToken}/>} /> */}
        </Routes>
           <NewFooter token={token} />
      </HelmetProvider>
     
    </div>
  );
};

export default CustomerRoutes;
